jQuery(function($) {
	$('div.custom-search form input[type="text"]').on('keyup', function(ev) {
		var $this = $(this);
		var val = $.trim($this.val());
		$this.siblings('input[type="submit"]').prop('disabled', !val.length);
	})
});